module.exports = __webpack_public_path__ + "img/check-in.4ff08cc1.svg";